import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('App error boundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="grain min-h-screen flex items-center justify-center p-6">
          <div className="card-glow rounded-2xl p-8 max-w-md w-full text-center">
            <h1 className="font-serif text-2xl text-[#f2ecdf] mb-3">Algo deu errado</h1>
            <p className="text-sm text-[#a89e87] mb-6">
              Ocorreu um erro inesperado. Recarregue a página para tentar novamente.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="btn-gold px-5 py-2.5 rounded-md text-sm font-medium"
            >
              Recarregar página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
